<template>
    <v-dialog
        :value="isOpen"
        max-width="300px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <template>
                    <h1 class="text-subtitle-1">
                        Edycja zaraportowanego nakładu
                    </h1>
                </template>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="singleReport.reportAmount"
                            v-mask="'#######'"
                            label="Zaraportowany nakład"
                            outlined
                            dense
                            :loading="actionLoading"
                            :error-messages="reportAmountErrors"
                            required
                        />
                    </v-col>
                </v-row>
            </div>
            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="saveReport()"
                >
                    <template>
                        Zapisz
                    </template>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer, between } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'UpdateReportAmountDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        reportData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            actionLoading: false,
            singleReport: {
                reportAmount: null,
                currentlyReportedQuantity: null
            }
        }
    },
    validations() {
        return {
            singleReport: {
                reportAmount: {
                    required,
                    integer,
                    between: between(0, this.maxReportAmount)
                }
            }
        }
    },
    computed: {
        canOverReport() {
            return this.reportData?.productionSite?.reportOverMaxAmount
        },
        maxReportAmount() {
            return this.canOverReport ? Infinity : (this.reportData.leftAmount + this.reportData.reportAmount)
        },
        maxReportAmountHint() {
            return this.canOverReport ? 'większą od 0' : `z zakresu 0-${this.reportData.leftAmount + this.reportData.reportAmount}`
        },
        // Walidacje
        reportAmountErrors() {
            const errors = []

            if (!this.$v.singleReport.reportAmount.$dirty) return errors

            if (!this.$v.singleReport.reportAmount.integer) {
                errors.push('Niepoprawny format.')
            }

            if (!this.$v.singleReport.reportAmount.required || !this.$v.singleReport.reportAmount.between) {
                errors.push(`Proszę podać wartość ${this.maxReportAmountHint}`)
            }

            return errors
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.singleReport = JSON.parse(JSON.stringify(this.reportData))
            } else {
                setTimeout(() => {
                    this.$v.$reset()
                    this.singleReport = {}
                }, 500)
            }
        }
    },
    methods: {
        saveReport() {
            this.$v.$touch()
            this.singleReport.currentlyReportedQuantity = this.singleReport.reportAmount

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            
            this.$store.dispatch('reports/updateReport', {
                id: this.reportData.id,
                payload: this.singleReport
            })
                .then(response => {
                    this.reportResponse = response.data
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.onClose()
                    this.$emit('on-save', this.reportResponse)
                })
        },
        onClose() {
            this.actionLoading = false
            this.$emit('on-close')
            this.$v.$reset()
            setTimeout(() => {
                this.singleReport = {}
            }, 500)
        },
    }
}
</script>